var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.32594590de56232cfc9e8b2cfe3ce682.svg#s';
                    var viewUrl = 'sprites.32594590de56232cfc9e8b2cfe3ce682.svg#view-s';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 104 36',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };